import { SENSOR_FUSION_DATA_LAYERS } from '@/types/shared/navigation-tabs.enums';

interface Graph {
  id: string;
  enabled: boolean;
  [key: string]: any;
}

interface Config {
  dataLayers?: Array<{
    id: string;
    graphs?: Graph[];
  }>;
}

interface InitialEnabledGraphs {
  [key: string]: string[];
}

/**
 * Extract graphs from config for a specific data layer
 */
export function getGraphsByDataLayer(config: Config | undefined, dataLayerId: string): Graph[] {
  return config?.dataLayers?.find((el: any) => el.id === dataLayerId)?.graphs ?? [];
}

/**
 * Extract all graph configurations from config
 */
export function extractGraphConfigurations(config: Config | undefined) {
  const visualAIBeltGraphs = getGraphsByDataLayer(config, 'beltMisalignment');
  const visualAIRockGraphs = getGraphsByDataLayer(config, 'rockSize');
  return {
    visualAIBeltGraphs,
    visualAIRockGraphs,
  };
}

/**
 * Initialize enabled graphs based on config
 */
export function initializeEnabledGraphs(visualAIBelt: Graph[], visualAIRock: Graph[]): InitialEnabledGraphs {
  return {
    [SENSOR_FUSION_DATA_LAYERS.beltMisalignment]: visualAIBelt?.filter((el: any) => el.enabled).map((el: any) => el.id),
    [SENSOR_FUSION_DATA_LAYERS.rockSize]: visualAIRock?.filter((el: any) => el.enabled).map((el: any) => el.id),
  };
}

/**
 * Create initialization key for tracking graph config changes
 */
export function createInitializationKey(
  selectedComponentId: string | null | undefined,
  selectedPart: string | null | undefined,
  visualAIBeltGraphs: Graph[],
  visualAIRockGraphs: Graph[]
): string {
  return `${selectedComponentId}-${selectedPart}-${visualAIBeltGraphs?.length}-${visualAIRockGraphs?.length}`;
}
